import React from "react";
import { observer, inject } from "mobx-react";
import { injectIntl } from "react-intl";

import EditableWithMentions from "./EditableWithMentions";
import { NOTE_COMMENT_MAX_LENGTH } from "./constants";

@injectIntl
@inject("rootStore")
@observer
export default class Comment extends React.Component {
  constructor(props) {
    super(props);

    this.canEdit = props.rootStore.authorizationStore.canEditComment(
      props.comment
    );
  }

  render() {
    const { comment, note, intl } = this.props;

    // const canEdit = CAN_EDIT_COMMENT(note.laneStore.rootStore, comment);

    return (
      <div className="note-comment-container" style={{ position: "relative" }}>
        <div className="comment-user-photo-container">
          <img
            className="comment-form-user-photo"
            src={comment.creator.profilePhotoUrl}
          />
        </div>

        <div className="comment-body-container">
          <div className="comment-date">
            {intl.formatRelative(comment.createdAt)}
          </div>
          <div className="comment-editable-container">
            <EditableWithMentions
              value={comment.body}
              note={note}
              comment={comment}
              canDelete={this.canEdit}
              canEdit={this.canEdit && false}
              showDelete
              onEdit={value => note.editComment(comment, value)}
              onDelete={() => note.deleteComment(comment)}
              maxLength={NOTE_COMMENT_MAX_LENGTH}
            />
          </div>
        </div>
        <hr />
      </div>
    );
  }
}
